import React from 'react';
import Layout from '../../../components/Layout';
import NotificationList from './NotificationList';






class Notifications extends React.Component {

    async componentDidMount() {
        await this.props.getNotificationList()
        await this.props.readNotificationList()
    }
    render() {
        return (
            <Layout>
                <div className="content-tours">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 tour-headText">
                                <h2>Notifications</h2>
                                <hr />
                            </div>
                        </div>
                        <div class="row">
                            <NotificationList
                                removeNotification={this.props.removeNotification}
                                notification={this.props.notification} />
                        </div>
                    </div>
                </div>

            </Layout>
        )
    }
}

export default Notifications


// WEBPACK FOOTER //
// src/routes/notification/components/Notifications.js